import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import { Modal, ModalBody, ModalFooter, Button, Input, Form, ToggleSwitch } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import { resetEmailRequest, clearRedux } from 'Redux/actions';

//Helpers
import { copyToClipboard } from 'Core/data/Helpers';

const ResetEmail = (props) => {
    const { isPMUser } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const { openModal, loading, result, entity, callback } = useSelector(state => state.resetEmailRedux);
    const [newEmail, setNewEmail] = useState("");

    const closeModal = () => {
        dispatch(clearRedux("RESET_EMAIL"));
        setNewEmail("");
    }

    const applyChanges = () => {

        if(newEmail === entity.email){
            NotificationManager.error(
                messages['reset_email_email_already_registered'],
                messages['reset_email_title'],
                3000,
            );
            return;
        }

        let payload = {
            id: entity?.id,
            entityName: entity?.entityName,
            username: entity?.username,
            newEmail: newEmail,
            isPMUser
        }
        dispatch(resetEmailRequest(payload))
    }

    useEffect(() => {
        if (result) {
            if (result?.reset) {
                NotificationManager.success(
                    messages['reset_email_success_message'],
                    messages['reset_email_title'],
                    3000,
                );
                closeModal();
                callback && callback();
            } else {
                let errorMessage = messages['reset_email_error_message'];
                if (result?.error?.error.includes("The email is already registered"))
                    errorMessage = messages['reset_email_email_already_registered'];
                NotificationManager.error(
                    errorMessage,
                    messages['reset_email_title'],
                    3000,
                );
            }
            dispatch(clearRedux("RESET_EMAIL", { result: null }))
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['reset_email_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div className="edit-swap-disabled-input" style={{ marginBottom: 5 }}>
                            <Input
                                label={messages['reset_email_current_email']}
                                placeholder={messages['reset_email_current_email']}
                                value={entity.email}
                                //onChange={(value) => setCurrentUsername(value)}
                                disabled
                                
                            />
                        </div>
                        <div className="edit-swap-disabled-input" style={{ marginBottom: 5 }}>
                            <Input
                                label={messages['reset_email_new_email']}
                                placeholder={messages['reset_email_new_email']}
                                autoComplete="new-password"
                                value={newEmail}
                                onChange={(value) => setNewEmail(value)}
                                required
                                requiredMessage={messages['required_field']}
                                email
                                emailMessage={messages['email_is_invalid']}

                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['common_change']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ResetEmail;